import { render, staticRenderFns } from "./Modulo.vue?vue&type=template&id=718bb428&scoped=true"
import script from "./Modulo.vue?vue&type=script&lang=ts"
export * from "./Modulo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718bb428",
  null
  
)

export default component.exports